/**
 * Debug hook for monitoring connection API call patterns
 */

import { useEffect } from 'react';
import { getApiCallStats, logDebugSummary } from '../utils/debugUtils';

export const useConnectionDebug = () => {
  useEffect(() => {
    // Check for excessive API calls every 10 seconds
    const interval = setInterval(() => {
      const stats = getApiCallStats();
      
      // Check for potential issues
      const connectionStatusCalls = stats['/connection/status']?.count || 0;
      const connectionRefreshCalls = stats['/connection/refresh']?.count || 0;
      
      // Log warning if too many calls detected
      if (connectionStatusCalls > 5 || connectionRefreshCalls > 3) {
        console.warn('🚨 Excessive connection API calls detected:');
        console.table(stats);
        logDebugSummary();
      }
    }, 10000);
    
    return () => clearInterval(interval);
  }, []);
  
  // Return utility functions for manual debugging
  return {
    getStats: getApiCallStats,
    logSummary: logDebugSummary
  };
};